import React, { useState } from 'react';
import { Toaster } from 'sonner';
import '../styles/new.css';
import BookingModal from '../components/BookingModal';
import CoachingEnquiryModal from '../components/CoachingEnquiryModal';
import { NlHeader } from '../components/new/NlHeader';
import { NlHero, NlMarquee } from '../components/new/NlHero';
import { NlWhyPadel, NlFacilities } from '../components/new/NlWhyPadel';
import { NlLocations } from '../components/new/NlLocations';
import { NlGallery } from '../components/new/NlGallery';
import { NlCoaching, NlTestimonials, NlWhyChoose } from '../components/new/NlCoaching';
import { NlBranding, NlFranchise } from '../components/new/NlForms';
import { NlFaq, NlFinalCta, NlFooter, NlWhatsApp } from '../components/new/NlFooter';

export default function NewLandingPage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [location, setLocation] = useState(null);
  const [coachingOpen, setCoachingOpen] = useState(false);
  const [coaching, setCoaching] = useState('');

  const openBooking = (loc = null) => { setLocation(typeof loc === 'string' ? loc : null); setBookingOpen(true); };
  const closeBooking = () => { setBookingOpen(false); setLocation(null); };
  const openCoaching = (title = '') => { setCoaching(title); setCoachingOpen(true); };
  const closeCoaching = () => { setCoachingOpen(false); setCoaching(''); };

  return (
    <div className="nl" data-testid="nl-page">
      <NlHeader onBook={openBooking} />
      <NlHero onBook={openBooking} />
      <NlMarquee />
      <NlWhyPadel />
      <NlFacilities />
      <NlLocations onBook={openBooking} />
      <NlGallery />
      <NlCoaching onEnquire={openCoaching} />
      <NlTestimonials />
      <NlWhyChoose />
      <NlBranding />
      <NlFranchise />
      <NlFaq />
      <NlFinalCta onBook={openBooking} onEnquire={openCoaching} />
      <NlFooter />
      <NlWhatsApp />

      <BookingModal isOpen={bookingOpen} onClose={closeBooking} preselectedLocation={location} />
      <CoachingEnquiryModal isOpen={coachingOpen} onClose={closeCoaching} selectedCoaching={coaching} />
      <Toaster theme="dark" position="bottom-center" richColors />
    </div>
  );
}
